module.exports = "data:text/x-markdown;base64,QSBsb25nIHRpbWUgYWdvIGluIGEgZ2FsYXh5IGZhciwgZmFyIGF3YXkuLi4gYSBuZXcgREFPIHdhcyBjcmVhdGVkLiBDYW4geW91IHN0ZWFsIGFsbCB0aGUgWU9EQSB0b2tlbnMgYmVsb25naW5nIHRvIGBNYXlUaGVGb3JjZUJlV2l0aFlvdWAgY29udHJhY3Q/Cg=="


//////////////////
// WEBPACK FOOTER
// ./gamedata/descriptions/levels/maytheforcebewithyou.md
// module id = 1837
// module chunks = 0